export default "__VITE_ASSET__CcxkQEXp__"